import axios from "axios";
import qs from "qs";
import { getUser } from "../database/UserDal";
import { Platform } from "react-native";

var baseUrl = "https://panel.asandarman.ir/AD2/api/web/v1/";
// var baseUrl = 'http://212.33.206.20/AD2/api/web/v1/'

function log(error, message) {
  console.log(message);
}
function getHeader() {
  var user = getUser();
  if (user != null) {
    return "Bearer " + user.token;
  }
}

export const refreshToken = (callback) => {
  axios
    .post(
      baseUrl + "servants/refreshtoken",
      {},
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const loginRequest = (mobile, callback) => {
  axios
    .post(
      baseUrl + "servants/loginservant",
      qs.stringify({
        cellphone: mobile,
        typedevice: "web",
      })
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const activationRequest = (active_code, callback) => {
  axios
    .post(
      baseUrl + "servants/activeservant",
      qs.stringify({
        active_code: active_code,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const rulesRequest = (callback) => {
  axios
    .get(baseUrl + "informations/rules/servant", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const myProfileRequest = (callback) => {
  axios
    .get(baseUrl + "servants/getmyprofile", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const sectionsRequest = (callback) => {
  axios
    .get(baseUrl + "informations/getsections", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const addFeedbackRequest = (subject, body, id_section, callback) => {
  axios
    .post(
      baseUrl + "informations/addfeedback",
      qs.stringify({
        subject: subject,
        body: body,
        id_section: id_section,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const cancellSessionRequest = (id_session, callback) => {
  axios
    .post(
      baseUrl + "servants/cancelsession",
      qs.stringify({
        id_session: id_session,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const notifictionRequest = (callback) => {
  axios
    .get(baseUrl + "servants/alldeclarations", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const notifictionNumberRequest = (callback) => {
  axios
    .get(baseUrl + "servants/numberofdeclarations", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const walletInfoRequest = (callback) => {
  axios
    .get(baseUrl + "servants/baginfo", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const walletChargeRequest = (price, callback) => {
  axios
    .post(
      baseUrl + "servants/shargebag",
      qs.stringify({
        price: price,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const aboutussRequest = (callback) => {
  axios
    .get(baseUrl + "informations/aboutus", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const supportNumberRequest = (callback) => {
  axios
    .get(baseUrl + "informations/suportnumber", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const myStatusRequest = (callback) => {
  axios
    .get(baseUrl + "servants/getstatusjob", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const changeStatusRequest = (jobStatus, callback) => {
  axios
    .post(
      baseUrl + "servants/changestatusjob",
      qs.stringify({
        status_job: jobStatus,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const numberOrdersRequest = (callback) => {
  axios
    .get(baseUrl + "servants/numberorders", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const getLocationRequest = (callback) => {
  axios
    .get(baseUrl + "servants/getlocation", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const orderListRequest = (callback) => {
  axios
    .get(baseUrl + "servants/orderslist", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const disagreeOrderRequest = (orderId, callback) => {
  axios
    .post(
      baseUrl + "servants/disagreeorder",
      qs.stringify({
        id_order: orderId,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const acceptOrderRequest = (orderId, callback) => {
  axios
    .post(
      baseUrl + "servants/acceptorder",
      qs.stringify({
        id: orderId,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const updateLocationRequest = (lat, lng, callback) => {
  axios
    .post(
      baseUrl + "servants/updatelocation",
      qs.stringify({
        // 'lat': 35.696504338668,
        // 'lng': 51.387151477722,
        lat: lat,
        lng: lng,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const getStatusRequest = (callback) => {
  axios
    .get(baseUrl + "servants/getstatusjob", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const getNumberRequest = (callback) => {
  axios
    .get(baseUrl + "servants/numberorders", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const getMyOrdersRequest = (callback) => {
  axios
    .get(baseUrl + "servants/myorderslist", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const getMyOrderInfoRequest = (id, callback) => {
  axios
    .get(baseUrl + "servants/orderdetails/" + id, {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const reasonsRequest = (callback) => {
  axios
    .get(baseUrl + "servants/reasons", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const videoRequest = (callback) => {
  axios
    .get(baseUrl + "informations/video", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const revenueRequest = (month, callback) => {
  axios
    .get(baseUrl + `servants/revenue?month=${month}`, {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const saveTokenRequest = (token, callback) => {
  axios
    .post(
      baseUrl + "servants/savetokenpush",
      qs.stringify({
        token: token,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const cancelOrderRequest = (id_order, reasons_ids, callback) => {
  axios
    .post(
      baseUrl + "servants/cancelorder",
      qs.stringify({
        id_order: id_order,
        reasons_ids: reasons_ids,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const arrivedRequest = (id_order, callback) => {
  axios
    .post(
      baseUrl + "servants/arrivedtohome",
      qs.stringify({
        id_order: id_order,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const arrivedSessionRequest = (id_session, callback) => {
  axios
    .post(
      baseUrl + "servants/arrivedsession",
      qs.stringify({
        id_session: id_session,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const hamradRequest = (id_order, taxi, callback) => {
  axios
    .post(
      baseUrl + "servants/taxiorder",
      qs.stringify({
        id_order: id_order,
        taxi: taxi,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const hamradSessionRequest = (id_session, taxi, callback) => {
  axios
    .post(
      baseUrl + "servants/taxisession",
      qs.stringify({
        id_session: id_session,
        taxi: taxi,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const endOrderRequest = (id_order, callback) => {
  axios
    .post(
      baseUrl + "servants/endofwork",
      qs.stringify({
        id_order: id_order,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const rateOrderRequest = (id_order, satisfy, comment, callback) => {
  axios
    .post(
      baseUrl + "servants/satisfysick",
      qs.stringify({
        id_order: id_order,
        satisfy: satisfy,
        comment: comment,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const startSessionRequest = (id_session, callback) => {
  axios
    .post(
      baseUrl + "servants/startsession",
      qs.stringify({
        id_session: id_session,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const endSessionRequest = (id_session, callback) => {
  axios
    .post(
      baseUrl + "servants/endsession",
      qs.stringify({
        id_session: id_session,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const askConditionRequest = (id_order, condition, callback) => {
  axios
    .post(
      baseUrl + "servants/favorableconditions",
      qs.stringify({
        id_order: id_order,
        condition: condition,
      }),
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
export const logoutRequest = (callback) => {
  axios
    .post(
      baseUrl + "servants/logout",
      {},
      {
        headers: {
          Authorization: getHeader(),
        },
      }
    )
    .then((response) => {
      log(true, response);
      callback(true, response.data);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};

export const versionAppRequest = (callback) => {
  axios
    .get(baseUrl + "informations/versionapp", {
      headers: {
        Authorization: getHeader(),
      },
    })
    .then((response) => {
      log(true, response);
      callback(true, response);
    })
    .catch((error) => {
      log(false, error);
      callback(false, error);
    });
};
